import React from 'react';
import styled from 'styled-components';

const StyledLine = styled.div`
  position: relative;
  background-color: white;
  height: 20px;
  width: 100%;
`;

const Line = () => (
  <StyledLine />
);

export default Line;
